'kiwi public';

import UserBox from '@/components/UserBox';
import SidebarState from './SidebarState';
import SidebarAboutBuffer from './SidebarAboutBuffer';
import SidebarSectionSettings from './SidebarSectionSettings';
import Nicklist from './Nicklist';
export { SidebarState as State };
export default {
  components: {
    SidebarAboutBuffer: SidebarAboutBuffer,
    SidebarSectionSettings: SidebarSectionSettings,
    Nicklist: Nicklist,
    UserBox: UserBox
  },
  props: ['network', 'buffer', 'sidebarState'],
  computed: {
    section: function section() {
      if (this.sidebarState.activeComponent) {
        return 'component';
      }
      return this.sidebarState.section();
    }
  },
  created: function created() {
    var _this = this;
    this.listen(this.$state, 'sidebar.tab.show', function (tabName) {
      _this.showTab(tabName);
    });
  },
  methods: {
    showTab: function showTab(tabName) {
      this.$refs.tabs.setActiveByName(tabName);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Sidebar"]
window._kiwi_exports.components.Sidebar = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
